
import { Component, Prop, Vue } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import CreateFirmwareVersionDialog from "./CreateFirmwareVersionDialog.vue";
import { FirmwareVersion as FirmwareVersionDto } from "@/api/dtos/FirmwareVersion.schema";
import type { FirmwareVersionUpload } from "@/api/firmwares";
import { Firmware } from "@/api/dtos/Firmware.schema";
import * as firmwareApi from "@/api/firmwares";

@Component({
  components: {
    CreateFirmwareVersionDialog,
    ContainerFrame,
  },
})
export default class FirmwareVersionsTable extends Vue {
  @Prop({ default: 110 }) width!: number;
  @Prop({ default: 30 }) height!: number;

  firmwareId: number = Number(this.$route.params.firmwareId)

  searchQuery = "";
  firmwareVersions: FirmwareVersionDto[] = [];
  firmware: Firmware | null = null;

  dialogFirmware: FirmwareVersionUpload = {
    version: "string",
    file: null,
  };
  showCreateDialog = false;

  readonly headers: {
    text: string;
    value: string;
    align?: "start" | "center" | "end";
  }[] = [
    { text: "Version", value: "version" },
    { text: "Datei Name", value: "fileName" },
    { text: "erstellt am", value: "createdAt" },
    { text: "", value: "actions", align: "center" },
  ];

  async mounted(): Promise<void> {

    await this.loadFirmware(this.firmwareId);
    // await this.loadFirmwareVersions(this.firmwareId);
  }

  async loadFirmware(firmwareId: number): Promise<void> {
    this.firmware = await firmwareApi.getFirmware(firmwareId);
  }

  async onDelete(id: number) {
    await firmwareApi.deleteFirmwareVersion(id);
    await this.loadFirmware(this.firmwareId);
  }

  onCreate(){
    this.dialogFirmware = {
      version: "",
      file: null,
    };
    this.showCreateDialog = true;
  }

  closeDialog(): void {
    console.log("SCHLIE?EN");
    this.showCreateDialog = false;
  }

  formatTimestamp(ts: string): string {
    const date = new Date(ts);
    return date.toLocaleString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }) + " Uhr";
  }

  onRowClicked(firmwareversion: FirmwareVersionDto): void {
    // placeholder – you can load details or open dialog here
    console.log("row clicked", firmwareversion);
    this.showCreateDialog = true;
    // e.g.:
    // this.showDetailsDialog = true;
  }
  

  async onAddFirmwareVersion(firmwareversion: FirmwareVersionUpload){
    // await firmwareApi.createFirmwareVersion(firmwareId,firmwareversion);
    await firmwareApi.createFirmwareVersion(this.firmwareId,firmwareversion);
    this.showCreateDialog = false;
    await this.loadFirmware(this.firmwareId);
  }
}
